<template>
	<div>
		<v-e24-nav-bar/>
			<div class="compliance-wizard">
				<headerResources isAccordions='true' :srcImage='img' :tall="tall" h1="Title 24 Wizard & Cost Estimator" />
				<residentialWizard />
			</div>
		<v-e24-footer :build="build"/>
	</div>
</template>
<script>
import headerResources from '@/commonSite/header.vue'
import residentialWizard from '@/components/complianceWizard/bothWizard'
import imageHeader from '@/img/complianceWizardBg4.jpg'
import readBuild from '../util/readBuild'

export default {
	name: 'compliance-wizard',
	components: {
		headerResources,
		residentialWizard
	},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
	},
	data: function () {
		return {
			build: '',
			img: imageHeader,
			tall: 90
		}
	}
}

</script>



// WEBPACK FOOTER //
// src/views/ComplianceWizard.vue